module.exports = __webpack_public_path__ + "assets/public/imgs/network-policy-samples/6-web-db-allow-all-ns.svg";